// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".empty-state{text-align:center;color:#989898;width:95%}.empty-state>.icon{opacity:.5}.empty-state p{margin-top:20px;margin-bottom:0}.empty-state .svg-inline--fa{font-size:75px}", ""]);
// Exports
module.exports = exports;
